import { TreeTableDesignTokens } from '@primeuix/themes/types/treetable';

export const TREE_TABLE_STYLES: TreeTableDesignTokens = {
  headerCell: {
    padding: '0.625rem 0.875rem',
  },
  bodyCell: {
    padding: '0.625rem 0.875rem',
  },
  css: () => `
    .p-treetable-sm {
      font-size: 0.875rem;
    }
        
    .p-treetable th,
    .p-treetable td {
      text-wrap: nowrap;
    }
      
    .p-treetable .p-paginator {
      width: 100%;
      align-self: start;

      .p-paginator-current {
        margin-left: auto;
        order: 4;
      }
    }

    .p-treetable:has(.p-paginator) {
      gap: 1rem;
    }
      
    .p-treetable-sm .p-paginator .p-select .p-select-label {
      font-size: 0.875rem !important;
      line-height: 0.875rem;
    }

    .p-treetable tr:not(.group) > td:first-child {
      padding-left: calc(2.25rem + (var(--group-depth) - 1) * 1rem) !important;
      padding-right: 1rem !important;
    }

    .p-treetable-scrollable-wrapper {
      overflow: auto;
    }
  `,
};
